// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"852":"bea1ec6b","2767":"aff21fd3","3101":"bea1ec6b","4192":"bea1ec6b","5813":"a9cc253f","5957":"d8d59d19"}[chunkId] + ".chunk.css";
};